(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1742],{

/***/ 42459:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/magazine/[id]",
      function () {
        return __webpack_require__(44960);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 82257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CD": function() { return /* binding */ useDrawPrizeMutation; },
/* harmony export */   "_X": function() { return /* binding */ useUserMissionsQuery; },
/* harmony export */   "bh": function() { return /* binding */ useReceivePrizeMutation; },
/* harmony export */   "ht": function() { return /* binding */ useCompleteMissionMutation; }
/* harmony export */ });
/* unused harmony exports UserMissionsDocument, CompleteMissionDocument, UserGamePrizeDocument, useUserGamePrizeQuery, DrawPrizeDocument, ReceivePrizeDocument */
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36492);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48228);
/* harmony import */ var _utils_fetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8391);


var UserMissionsDocument = "\n    query UserMissions {\n  userMissions {\n    missionRecords {\n      completionCount\n      completedAt\n      mission {\n        id\n        endAt\n        name\n        periodType\n        quantity\n        startAt\n        ticketType\n        type\n        visible\n        targetLink\n        maxCount\n      }\n      status\n    }\n    userId\n    userTickets {\n      id\n      quantity\n      ticketType\n      userId\n    }\n  }\n}\n    ";
var useUserMissionsQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)(variables === undefined ? [
        "UserMissions"
    ] : [
        "UserMissions",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(UserMissionsDocument, "UserMissions", variables), options);
};
useUserMissionsQuery.getKey = function(variables) {
    return variables === undefined ? [
        "UserMissions"
    ] : [
        "UserMissions",
        variables
    ];
};
useUserMissionsQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(UserMissionsDocument, "UserMissions", variables, options);
};
var CompleteMissionDocument = "\n    mutation CompleteMission($request: MissionCompleteRequestInput!) {\n  completeMission(request: $request)\n}\n    ";
var useCompleteMissionMutation = function(options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)([
        "CompleteMission"
    ], function(variables) {
        return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(CompleteMissionDocument, "CompleteMission", variables)();
    }, options);
};
useCompleteMissionMutation.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(CompleteMissionDocument, "CompleteMission", variables, options);
};
var UserGamePrizeDocument = "\n    query UserGamePrize($gameType: GameType!) {\n  userGamePrizes(gameType: $gameType) {\n    activePrizeStrategies {\n      gameType\n      id\n      prize {\n        amount\n        displayName\n        id\n        name\n        type\n        thumbnailUrl\n        formattedGuidance\n        winningImageUrl\n      }\n      quantity\n    }\n    gameType\n    userId\n    userPrizes {\n      drawnAt\n      id\n      prize {\n        amount\n        displayName\n        id\n        name\n        type\n        thumbnailUrl\n        formattedGuidance\n        winningImageUrl\n      }\n      quantity\n      receivedAt\n      status\n      userId\n    }\n  }\n}\n    ";
var useUserGamePrizeQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "UserGamePrize",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(UserGamePrizeDocument, "UserGamePrize", variables), options);
};
useUserGamePrizeQuery.getKey = function(variables) {
    return [
        "UserGamePrize",
        variables
    ];
};
useUserGamePrizeQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(UserGamePrizeDocument, "UserGamePrize", variables, options);
};
var DrawPrizeDocument = "\n    mutation DrawPrize($request: PrizeDrawRequestInput!) {\n  drawPrize(request: $request) {\n    prize {\n      amount\n      displayName\n      id\n      name\n      type\n      thumbnailUrl\n      formattedGuidance\n      winningImageUrl\n    }\n    quantity\n    userPrizeId\n  }\n}\n    ";
var useDrawPrizeMutation = function(options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)([
        "DrawPrize"
    ], function(variables) {
        return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(DrawPrizeDocument, "DrawPrize", variables)();
    }, options);
};
useDrawPrizeMutation.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(DrawPrizeDocument, "DrawPrize", variables, options);
};
var ReceivePrizeDocument = "\n    mutation ReceivePrize($request: PrizeReceiveRequestInput!) {\n  receivePrize(request: $request)\n}\n    ";
var useReceivePrizeMutation = function(options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)([
        "ReceivePrize"
    ], function(variables) {
        return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(ReceivePrizeDocument, "ReceivePrize", variables)();
    }, options);
};
useReceivePrizeMutation.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(ReceivePrizeDocument, "ReceivePrize", variables, options);
};


/***/ }),

/***/ 98436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ UserMissionTypeVo; }
/* harmony export */ });
var UserMissionTypeVo;
(function(UserMissionTypeVo) {
    UserMissionTypeVo["AdWatch"] = "AD_WATCH";
    UserMissionTypeVo["AttendanceCheck"] = "ATTENDANCE_CHECK";
    UserMissionTypeVo["MagazineRead"] = "MAGAZINE_READ";
    UserMissionTypeVo["QnaRead"] = "QNA_READ";
    UserMissionTypeVo["TodayMissionAllComplete"] = "TODAY_MISSION_ALL_COMPLETE";
    UserMissionTypeVo["Unknown"] = "UNKNOWN";
})(UserMissionTypeVo || (UserMissionTypeVo = {}));


/***/ }),

/***/ 74878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useBroadcastChannel; }
/* harmony export */ });
/* harmony import */ var broadcast_channel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12634);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


function useBroadcastChannel(channelName, options) {
    var broadcastChannelRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var onMessageRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var handlePostMessage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(message) {
        if (broadcastChannelRef.current) {
            broadcastChannelRef.current.postMessage(message);
        }
    }, []);
    var handleOnMessage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(messageCallback) {
        onMessageRef.current = messageCallback;
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var mounted = true;
        var channel = new broadcast_channel__WEBPACK_IMPORTED_MODULE_1__/* .BroadcastChannel */ .g0(channelName, options);
        var handleMessage = function(message) {
            var ref;
            if (!mounted) {
                return;
            }
            (ref = onMessageRef.current) === null || ref === void 0 ? void 0 : ref.call(onMessageRef, message);
        };
        channel.onmessage = handleMessage;
        broadcastChannelRef.current = channel;
        return function() {
            mounted = false;
            broadcastChannelRef.current = null;
            channel.close();
        };
    }, [
        channelName,
        options
    ]);
    return {
        postMessage: handlePostMessage,
        setOnMessage: handleOnMessage
    };
}


/***/ }),

/***/ 53962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mission_useMissionTimer; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/hooks/useTimer.ts

var useTimer = function(param) {
    var activated = param.activated;
    var ref = (0,react.useState)(0), timer = ref[0], setTimer = ref[1];
    (0,react.useEffect)(function() {
        if (!activated) {
            return;
        }
        var timer = setInterval(function() {
            setTimer(function(_time) {
                return _time + 1;
            });
        }, 1000);
        return function() {
            clearInterval(timer);
        };
    }, [
        activated
    ]);
    return {
        timer: timer
    };
};
/* harmony default export */ var hooks_useTimer = (useTimer);

;// CONCATENATED MODULE: ./src/hooks/mission/useMissionTimer.ts


var useMissionTimer = function(param) {
    var targetTime = param.targetTime, activated = param.activated;
    var ref = (0,react.useState)(false), missionCompleted = ref[0], setMissionCompleted = ref[1];
    var timer = hooks_useTimer({
        activated: activated && !missionCompleted
    }).timer;
    var displayTime = targetTime === timer ? "완료" : "".concat(targetTime - timer, "초");
    (0,react.useEffect)(function() {
        if (timer === targetTime) {
            setMissionCompleted(true);
        }
    }, [
        timer
    ]);
    return {
        time: timer,
        missionCompleted: missionCompleted,
        displayTime: displayTime
    };
};
/* harmony default export */ var mission_useMissionTimer = (useMissionTimer);


/***/ }),

/***/ 30283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17160);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_responsive__WEBPACK_IMPORTED_MODULE_1__);


var useIsResponsive = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true), isPc = ref[0], setIsPc = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isMobile = ref1[0], setIsMobile = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isTablet = ref2[0], setIsTablet = ref2[1];
    var mobile = (0,react_responsive__WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)({
        query: "(max-width:768px)"
    });
    var pc = (0,react_responsive__WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)({
        query: "(min-width:1024px)"
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (mobile) {
            setIsMobile(true);
            setIsTablet(false);
            setIsPc(false);
            return;
        }
        if (pc) {
            setIsTablet(false);
            setIsMobile(false);
            setIsPc(true);
            return;
        }
        setIsTablet(true);
        setIsMobile(false);
        setIsPc(false);
    }, [
        mobile,
        pc
    ]);
    return {
        isMobile: isMobile,
        isTablet: isTablet,
        isPc: isPc
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useIsResponsive);


/***/ }),

/***/ 44960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/layouts/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(83651);
// EXTERNAL MODULE: ./src/components/templates/communication/magazine/magazine-detail-template/index.tsx + 6 modules
var magazine_detail_template = __webpack_require__(41066);
// EXTERNAL MODULE: ./src/constants/url.ts
var url = __webpack_require__(26093);
// EXTERNAL MODULE: ./src/hooks/cuj/useAppInstallTopBanner.tsx
var useAppInstallTopBanner = __webpack_require__(40573);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/recoil/es/index.js
var es = __webpack_require__(53476);
// EXTERNAL MODULE: ./src/constants/logs/magazine/index.ts
var logs_magazine = __webpack_require__(72563);
// EXTERNAL MODULE: ./src/hooks/cuj/useAppDownloadCujModal.tsx + 1 modules
var useAppDownloadCujModal = __webpack_require__(11989);
// EXTERNAL MODULE: ./src/hooks/magazine/useGetMagazineDetail.ts
var useGetMagazineDetail = __webpack_require__(6150);
// EXTERNAL MODULE: ./src/hooks/magazine/useGetPrevNextMagazinePid.ts
var useGetPrevNextMagazinePid = __webpack_require__(54110);
// EXTERNAL MODULE: ./src/constants/common/index.ts
var common = __webpack_require__(95611);
// EXTERNAL MODULE: ./src/hooks/magazine/magazine.gql.impl.tsx
var magazine_gql_impl = __webpack_require__(44355);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./src/hooks/magazine/useGetRelatedMagazine.ts







var parseRelatedMagazines = function(data) {
    var parseMagazineListItem = function(magazine) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, magazine), {
            magazinePid: magazine.magazinePid,
            date: "".concat(dayjs_min_default()(magazine.createdAt).format("YYYY.MM.DD"))
        });
    };
    if (data) {
        return data.magazineRelatedMagazines.map(function(magazine) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, parseMagazineListItem(magazine)), {
                contentType: magazine.contentType,
                isArticle: magazine.contentType === "ARTICLE"
            });
        });
    }
    return [];
};
var useGetRelatedMagazine = function(magazinePid) {
    var ref = (0,magazine_gql_impl/* useGetMagazineRelatedMagazinesQuery */.yH)({
        request: {
            size: 4,
            magazinePid: magazinePid
        }
    }, {
        select: parseRelatedMagazines,
        staleTime: common/* SIX_HOURS_IN_MILLISECONDS */.At,
        cacheTime: common/* SIX_HOURS_IN_MILLISECONDS */.At
    }), tmp = ref.data, relatedMagazine = tmp === void 0 ? [] : tmp;
    return {
        relatedMagazine: relatedMagazine
    };
};
/* harmony default export */ var magazine_useGetRelatedMagazine = (useGetRelatedMagazine);
useGetRelatedMagazine.getKey = function(magazinePid) {
    return magazine_gql_impl/* useGetMagazineRelatedMagazinesQuery.getKey */.yH.getKey({
        request: {
            size: 4,
            magazinePid: magazinePid
        }
    });
};
useGetRelatedMagazine.prefetchQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient, magazinePid) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.prefetchQuery(magazine_gql_impl/* useGetMagazineRelatedMagazinesQuery.getKey */.yH.getKey({
                            request: {
                                magazinePid: magazinePid,
                                size: 4
                            }
                        }), magazine_gql_impl/* useGetMagazineRelatedMagazinesQuery.fetcher */.yH.fetcher({
                            request: {
                                magazinePid: magazinePid,
                                size: 4
                            }
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(queryClient, magazinePid) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/hooks/mission/mission.gql.impl.tsx
var mission_gql_impl = __webpack_require__(82257);
// EXTERNAL MODULE: ./src/hooks/mission/types.ts
var types = __webpack_require__(98436);
// EXTERNAL MODULE: ./src/hooks/mission/useBroadcastChannel.ts
var useBroadcastChannel = __webpack_require__(74878);
// EXTERNAL MODULE: ./src/hooks/mission/useMissionTimer.ts + 1 modules
var useMissionTimer = __webpack_require__(53962);
// EXTERNAL MODULE: ./src/hooks/qna/mobile/write/useCanProgressQnaWrite.tsx
var useCanProgressQnaWrite = __webpack_require__(61842);
// EXTERNAL MODULE: ./src/hooks/qna/useGetMagazineRelatedQna.ts
var useGetMagazineRelatedQna = __webpack_require__(35640);
// EXTERNAL MODULE: ./src/hooks/useAuthModal.tsx
var useAuthModal = __webpack_require__(71213);
// EXTERNAL MODULE: ./src/hooks/useClickContentLike.ts
var useClickContentLike = __webpack_require__(5872);
// EXTERNAL MODULE: ./src/hooks/useCustomRouter.tsx
var useCustomRouter = __webpack_require__(77196);
// EXTERNAL MODULE: ./src/hooks/useIsResponsive.tsx
var useIsResponsive = __webpack_require__(30283);
// EXTERNAL MODULE: ./src/hooks/useModal.tsx
var useModal = __webpack_require__(98266);
// EXTERNAL MODULE: ./src/hooks/useMoveToHospitalSearch.ts
var useMoveToHospitalSearch = __webpack_require__(17440);
// EXTERNAL MODULE: ./src/hooks/useMoveToTotalSearch.ts
var useMoveToTotalSearch = __webpack_require__(23483);
// EXTERNAL MODULE: ./src/hooks/useToast.tsx
var useToast = __webpack_require__(17722);
// EXTERNAL MODULE: ./src/recoil/atoms/common/auth.ts
var auth = __webpack_require__(4415);
// EXTERNAL MODULE: ./src/types/common.ts
var types_common = __webpack_require__(70138);
// EXTERNAL MODULE: ./src/types/magazine.ts
var types_magazine = __webpack_require__(45162);
// EXTERNAL MODULE: ./src/types/modal.ts
var modal = __webpack_require__(74701);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
// EXTERNAL MODULE: ./src/constants/pixel.ts
var pixel = __webpack_require__(4380);
// EXTERNAL MODULE: ./src/hooks/advertisement/useAdBanner.ts + 1 modules
var useAdBanner = __webpack_require__(48729);
// EXTERNAL MODULE: ./src/models/ad/list.ts
var list = __webpack_require__(70847);
// EXTERNAL MODULE: ./src/utils/pixel/pixel.ts
var pixel_pixel = __webpack_require__(5863);
// EXTERNAL MODULE: ./src/constants/logs/deeplink/index.ts
var deeplink = __webpack_require__(60643);
// EXTERNAL MODULE: ./src/shared/hooks/index.ts + 1 modules
var hooks = __webpack_require__(95613);
// EXTERNAL MODULE: ./src/shared/types/index.ts + 1 modules
var shared_types = __webpack_require__(9628);
// EXTERNAL MODULE: ./src/hooks/useNavigate.ts + 1 modules
var useNavigate = __webpack_require__(85180);
;// CONCATENATED MODULE: ./src/hooks/magazine/useMagazineDetailViewModel.ts






































var useMagazineDetailViewModel = function(param) {
    var magazinePid = param.magazinePid, client = param.client, missionId = param.missionId;
    var ref, ref1;
    var ref2 = (0,useCustomRouter/* default */.Z)(), pageName = ref2.pageName, moveToPage = ref2.moveToPage;
    var showToast = (0,useToast/* default */.Z)().showToast;
    var setShowAuthModal = (0,useAuthModal/* default */.Z)(true).setShowAuthModal;
    var token = (0,es.useRecoilValue)(auth/* tokenState */.J1);
    var ref3 = (0,useModal/* default */.Z)(), showModal = ref3.showModal, closeModal = ref3.closeModal;
    var ref4 = magazine_useGetRelatedMagazine(magazinePid), magazines = ref4.relatedMagazine;
    var ref5 = (0,useGetPrevNextMagazinePid/* default */.Z)(magazinePid, types_magazine/* MagazineType.ARTICLE */.rL.ARTICLE), prevMagazinePid = ref5.prevMagazinePid, nextMagazinePid = ref5.nextMagazinePid;
    var moveToHospital = (0,useMoveToHospitalSearch/* default */.Z)().moveToHospital;
    var moveToTotalSearch = (0,useMoveToTotalSearch/* default */.Z)().moveToTotalSearch;
    var isMobile = (0,useIsResponsive/* default */.Z)().isMobile;
    var ref6 = (0,useClickContentLike/* default */.Z)(magazinePid), likeContent = ref6.likeContent, cancelLikeContent = ref6.cancelLikeContent;
    var magazine = (0,useGetMagazineDetail/* default */.Z)(magazinePid);
    var magazineRelatedQna = (0,useGetMagazineRelatedQna/* default */.Z)(magazinePid).magazineRelatedQna;
    var completeMissionMutation = (0,mission_gql_impl/* useCompleteMissionMutation */.ht)();
    var broadCastChannel = (0,useBroadcastChannel/* useBroadcastChannel */.t)("user-missions");
    var navigate = (0,useNavigate/* default */.Z)();
    var airbridgeDynamicLink = (0,hooks/* useAirbridgeDynamicLink */.e)();
    var ref7 = (0,useAdBanner/* default */.Z)(list/* AdPageType.MagazineDetail */.hO.MagazineDetail, client), bannerAdExchange = ref7.bannerAdExchange, handleSendExposureLog = ref7.handleSendExposureLog;
    var MISSION_TARGET_TIME = 10;
    var ref8 = (0,useMissionTimer/* default */.Z)({
        activated: Boolean(missionId),
        targetTime: MISSION_TARGET_TIME
    }), displayTime = ref8.displayTime, missionCompleted = ref8.missionCompleted;
    var copyUrl = (0,react.useMemo)(function() {
        return "".concat("https://doctornow.co.kr").concat(types_common/* ROUTES.MAGAZINE.DETAIL.path */.Z6.MAGAZINE.DETAIL.path, "/").concat(magazine === null || magazine === void 0 ? void 0 : magazine.magazinePid);
    }, [
        magazine === null || magazine === void 0 ? void 0 : magazine.magazinePid
    ]);
    var magazineContent = (0,react.useMemo)(function() {
        if ((0,RNPlugins/* isWebView */.vp)()) {
            return magazine === null || magazine === void 0 ? void 0 : magazine.mobileContent;
        }
        return magazine === null || magazine === void 0 ? void 0 : magazine.content;
    }, [
        magazine === null || magazine === void 0 ? void 0 : magazine.content,
        magazine === null || magazine === void 0 ? void 0 : magazine.mobileContent
    ]);
    var setIsCujModalTrackingInfo = (0,useAppDownloadCujModal/* default */.Z)().setIsCujModalTrackingInfo;
    var clickProgressWrite = (0,useCanProgressQnaWrite/* default */.Z)().clickProgressWrite;
    var departmentTags = (0,react.useMemo)(function() {
        return magazine === null || magazine === void 0 ? void 0 : magazine.tags.filter(function(tag) {
            return tag.tagType === types_magazine/* MagazineTagType.DEPARTMENT */.Zg.DEPARTMENT;
        });
    }, [
        magazine === null || magazine === void 0 ? void 0 : magazine.tags
    ]);
    var diseaseTags = (0,react.useMemo)(function() {
        return magazine === null || magazine === void 0 ? void 0 : magazine.tags.filter(function(tag) {
            return tag.tagType === types_magazine/* MagazineTagType.DISEASE */.Zg.DISEASE;
        });
    }, [
        magazine === null || magazine === void 0 ? void 0 : magazine.tags
    ]);
    var symptomTags = (0,react.useMemo)(function() {
        return magazine === null || magazine === void 0 ? void 0 : magazine.tags.filter(function(tag) {
            return tag.tagType === types_magazine/* MagazineTagType.SYMPTOM */.Zg.SYMPTOM;
        });
    }, [
        magazine === null || magazine === void 0 ? void 0 : magazine.tags
    ]);
    var totalRelatedMagazinesTitle = (0,react.useMemo)(function() {
        return isMobile ? "다른 콘텐츠도 읽어보세요" : "이런 콘텐츠는 어떠세요?";
    }, [
        isMobile
    ]);
    var magazineTagNames = (0,react.useMemo)(function() {
        return magazine && magazine.tagNames ? magazine.tagNames.map(function(name) {
            return name;
        }) : [];
    }, [
        magazine
    ]);
    var bottomButtonText = (0,react.useMemo)(function() {
        var ref;
        var shouldShowContraceptiveText = (magazine === null || magazine === void 0 ? void 0 : (ref = magazine.tagNames) === null || ref === void 0 ? void 0 : ref.some(function(tag) {
            return tag.includes("사후피임");
        })) && !client.isWebView;
        if (shouldShowContraceptiveText) {
            return "빠르게 사후피임약 처방받기";
        }
        switch(magazine === null || magazine === void 0 ? void 0 : magazine.bottomButtonType){
            case types_magazine/* MagazineBottomButtonType.DIAGNOSIS */.wK.DIAGNOSIS:
                return "비대면 진료 받으러 가기";
            case types_magazine/* MagazineBottomButtonType.QUESTION */.wK.QUESTION:
            default:
                return "지금 바로 의료 상담받기";
        }
    }, [
        magazine === null || magazine === void 0 ? void 0 : magazine.bottomButtonType,
        client.isWebView
    ]);
    var shouldShowEventText = function() {
        return !(0,RNPlugins/* isWebView */.vp)();
    };
    var airbridgeLinkOptions = {
        sub_id: magazine === null || magazine === void 0 ? void 0 : magazine.magazinePid,
        sub_id_1: magazine === null || magazine === void 0 ? void 0 : magazine.title,
        sub_id_2: (diseaseTags === null || diseaseTags === void 0 ? void 0 : (ref = diseaseTags[0]) === null || ref === void 0 ? void 0 : ref.name) || "",
        sub_id_3: (departmentTags === null || departmentTags === void 0 ? void 0 : (ref1 = departmentTags[0]) === null || ref1 === void 0 ? void 0 : ref1.name) || ""
    };
    var getAirbridgeDynamicLink = function(options) {
        var linkType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : shared_types/* EAirbridgeLinkType.GENERAL */.Q.GENERAL;
        return airbridgeDynamicLink.getDynamicLink(options, linkType);
    };
    var bottomButtonDynamicLink = function() {
        airbridgeDynamicLink.navigateWithTracking(deeplink/* DeeplinkLoggerEventName.ClickCtaButton */.l.ClickCtaButton, (0,_object_spread/* default */.Z)({
            campaign: "web_content_magazine",
            content: "web_content_flt_details",
            term: bottomButtonText
        }, airbridgeLinkOptions));
    };
    var handleLikeClick = (0,react.useCallback)(function() {
        (0,logger/* mobileLogger */.Pp)({
            logger: {
                eventName: "health_tip_detail_".concat((magazine === null || magazine === void 0 ? void 0 : magazine.isLikedByMe) ? "disLike" : "like", "_button_click"),
                pageName: pageName
            }
        });
        if (!token) {
            showToast({
                message: "로그인 후 이용할 수 있어요."
            });
            setShowAuthModal(true);
            return;
        }
        if (magazine === null || magazine === void 0 ? void 0 : magazine.isLikedByMe) {
            cancelLikeContent();
            return;
        }
        likeContent();
    }, [
        cancelLikeContent,
        likeContent,
        magazine === null || magazine === void 0 ? void 0 : magazine.isLikedByMe,
        pageName
    ]);
    var moveOtherMagazine = function(magazine) {
        moveToPage({
            webLink: magazine.isArticle ? "".concat(types_common/* ROUTES.MAGAZINE.DETAIL.path */.Z6.MAGAZINE.DETAIL.path, "/").concat(magazinePid) : "".concat(types_common/* ROUTES.FAQ.DETAIL.path */.Z6.FAQ.DETAIL.path, "/").concat(magazinePid),
            mobileScreenName: magazine.isArticle ? types_common/* ROUTES.MAGAZINE.DETAIL.appScreenName */.Z6.MAGAZINE.DETAIL.appScreenName : types_common/* ROUTES.FAQ.DETAIL.appScreenName */.Z6.FAQ.DETAIL.appScreenName,
            params: {
                id: magazine.magazinePid,
                missionId: null
            }
        });
    };
    var onClickShare = function() {
        (0,logger/* logger */.kg)({
            pageName: pageName,
            eventName: logs_magazine/* MAGAZINE_LOG_EVENT.UPPER_MAGAZINE_SHARE_CLICK */.W.UPPER_MAGAZINE_SHARE_CLICK
        });
    };
    var onRecordLog = function(logName) {
        (0,logger/* logger */.kg)({
            pageName: pageName,
            eventName: logName
        });
    };
    var onClickTag = function(tagName) {
        (0,logger/* magazineLogger */.Uj)({
            pageName: pageName,
            eventName: logs_magazine/* MAGAZINE_LOG_EVENT.CLICK_MAGAZINE_TAG */.W.CLICK_MAGAZINE_TAG,
            payload: {
                magazinePid: magazinePid,
                tagType: types_magazine/* MagazineTagType.FREE */.Zg.FREE,
                tagName: tagName
            }
        });
        navigate.navigateToMagazineTagList({
            tagName: tagName
        });
    };
    var moveToSearch = function() {
        (0,logger/* mobileLogger */.Pp)({
            logger: {
                eventName: logs_magazine/* MAGAZINE_LOG_EVENT.MOVE_TO_SEARCH_PAGE_CLICK */.W.MOVE_TO_SEARCH_PAGE_CLICK,
                pageName: pageName
            }
        });
        moveToPage({
            webLink: types_common/* ROUTES.COMMON.SEARCH.path */.Z6.COMMON.SEARCH.path,
            mobileScreenName: types_common/* ROUTES.COMMON.SEARCH.appScreenName */.Z6.COMMON.SEARCH.appScreenName,
            params: {
                type: "magazine"
            }
        });
    };
    var moveToHospitalDetail = function(hospitalPid) {
        navigate.navigateToHospitalDetail({
            hospitalPid: hospitalPid
        });
    };
    var openExternalUrl = function(url) {
        if ((0,RNPlugins/* isWebView */.vp)()) {
            (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.OPEN_EXTERNAL_BROWSER */.nn.OPEN_EXTERNAL_BROWSER, {
                url: url
            });
            return;
        }
        window.open(url);
    };
    var moveToAuthorHospital = function(isDoctorProfile) {
        if (magazine === null || magazine === void 0 ? void 0 : magazine.hospitalPid) {
            var hospitalPid = magazine.hospitalPid;
            (0,logger/* magazineLogger */.Uj)({
                pageName: pageName,
                eventName: logs_magazine/* MAGAZINE_LOG_EVENT.CLICK_MOVE_HOSPITAL_FROM_MAGAZINE */.W.CLICK_MOVE_HOSPITAL_FROM_MAGAZINE,
                payload: {
                    magazinePid: magazinePid,
                    hospitalPid: hospitalPid,
                    buttonType: isDoctorProfile ? "doctor_profile" : "card"
                }
            });
            if (magazine.author.externalLinkUrl) {
                openExternalUrl(magazine.author.externalLinkUrl);
                return;
            }
            moveToHospitalDetail(hospitalPid);
        }
    };
    var navigateToMagazineAuthorDetail = function() {
        if (!magazine) {
            return;
        }
        navigate.navigateToMagazineAuthorDetail({
            authorPublicId: magazine.author.authorPublicId
        });
    };
    var onClickTopCta = function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.TopCtaClick */.$.TopCtaClick, (0,_object_spread/* default */.Z)({}, (diseaseTags === null || diseaseTags === void 0 ? void 0 : (ref = diseaseTags[0]) === null || ref === void 0 ? void 0 : ref.name) && {
            disease: diseaseTags === null || diseaseTags === void 0 ? void 0 : (ref1 = diseaseTags[0]) === null || ref1 === void 0 ? void 0 : ref1.name
        }, (departmentTags === null || departmentTags === void 0 ? void 0 : (ref2 = departmentTags[0]) === null || ref2 === void 0 ? void 0 : ref2.name) && {
            subject: departmentTags === null || departmentTags === void 0 ? void 0 : (ref3 = departmentTags[0]) === null || ref3 === void 0 ? void 0 : ref3.name
        }, (symptomTags === null || symptomTags === void 0 ? void 0 : (ref4 = symptomTags[0]) === null || ref4 === void 0 ? void 0 : ref4.name) && {
            symptom: symptomTags === null || symptomTags === void 0 ? void 0 : (ref5 = symptomTags[0]) === null || ref5 === void 0 ? void 0 : ref5.name
        }));
    };
    var handleStickyButton = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, _;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (0,logger/* magazineLogger */.Uj)({
                            eventName: logs_magazine/* MAGAZINE_LOG_EVENT.HEALTH_TIP_DETAIL_STICKY_BUTTON_CLICK */.W.HEALTH_TIP_DETAIL_STICKY_BUTTON_CLICK,
                            pageName: pageName,
                            payload: {
                                id: magazinePid,
                                type: (ref6 = magazine === null || magazine === void 0 ? void 0 : magazine.bottomButtonType) !== null && ref6 !== void 0 ? ref6 : "",
                                platform: client.clientType
                            }
                        });
                        pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.BottomCtaClick */.$.BottomCtaClick, (0,_object_spread/* default */.Z)({}, (diseaseTags === null || diseaseTags === void 0 ? void 0 : (ref = diseaseTags[0]) === null || ref === void 0 ? void 0 : ref.name) && {
                            disease: diseaseTags === null || diseaseTags === void 0 ? void 0 : (ref1 = diseaseTags[0]) === null || ref1 === void 0 ? void 0 : ref1.name
                        }, (departmentTags === null || departmentTags === void 0 ? void 0 : (ref2 = departmentTags[0]) === null || ref2 === void 0 ? void 0 : ref2.name) && {
                            subject: departmentTags === null || departmentTags === void 0 ? void 0 : (ref3 = departmentTags[0]) === null || ref3 === void 0 ? void 0 : ref3.name
                        }, (symptomTags === null || symptomTags === void 0 ? void 0 : (ref4 = symptomTags[0]) === null || ref4 === void 0 ? void 0 : ref4.name) && {
                            symptom: symptomTags === null || symptomTags === void 0 ? void 0 : (ref5 = symptomTags[0]) === null || ref5 === void 0 ? void 0 : ref5.name
                        }));
                        _ = magazine === null || magazine === void 0 ? void 0 : magazine.bottomButtonType;
                        switch(_){
                            case types_magazine/* MagazineBottomButtonType.DIAGNOSIS */.wK.DIAGNOSIS:
                                return [
                                    3,
                                    1
                                ];
                            case types_magazine/* MagazineBottomButtonType.QUESTION */.wK.QUESTION:
                                return [
                                    3,
                                    2
                                ];
                        }
                        return [
                            3,
                            2
                        ];
                    case 1:
                        if (client.isWebView) {
                            navigate.navigateCategorySelectWithJumpToHomeTab();
                        } else {
                            navigate.navigateToTelemedicineCategoriesScreen();
                        }
                        return [
                            3,
                            4
                        ];
                    case 2:
                        if (!client.isWebView) {
                            bottomButtonDynamicLink();
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            clickProgressWrite()
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleStickyButton() {
            return _ref.apply(this, arguments);
        };
    }();
    var magazineTocLogger = function() {
        (0,logger/* magazineLogger */.Uj)({
            eventName: logs_magazine/* MAGAZINE_LOG_EVENT.CLICK_MAGAZINE_TOC */.W.CLICK_MAGAZINE_TOC,
            pageName: pageName,
            payload: {
                id: magazinePid
            }
        });
    };
    var onClickPrevNextMagazine = function(magazinePid) {
        navigate.navigateToMagazineDetail({
            magazinePid: magazinePid
        });
    };
    var onClickRelatedQna = function(questionPid) {
        (0,logger/* magazineLogger */.Uj)({
            eventName: logs_magazine/* MAGAZINE_LOG_EVENT.MAGAZINE_RELATED_QNA_CLICK */.W.MAGAZINE_RELATED_QNA_CLICK,
            pageName: pageName,
            payload: {
                magazinePid: magazinePid,
                questionPid: questionPid
            }
        });
        navigate.navigateToQnaDetailWithJumpToQnaTab({
            questionPid: questionPid
        });
    };
    var extractTextFromChildren = function(children) {
        if (typeof children === "string") {
            return children;
        }
        if (typeof children === "number") {
            return String(children);
        }
        if (Array.isArray(children)) {
            return children.map(extractTextFromChildren).join("");
        }
        if (react.isValidElement(children) && children.props && children.props.children) {
            return extractTextFromChildren(children.props.children);
        }
        return "";
    };
    var onClickOuterLink = function(url) {
        (0,logger/* magazineLogger */.Uj)({
            eventName: logs_magazine/* MAGAZINE_LOG_EVENT.CLICK_OUTER_LINK */.W.CLICK_OUTER_LINK,
            pageName: pageName,
            payload: {
                magazinePid: magazinePid,
                url: url
            }
        });
        if ((0,RNPlugins/* isWebView */.vp)()) {
            navigate.navigateToPureWebViewAppScreen({
                uri: url
            });
        } else {
            window.open(url, "_blank");
        }
    };
    var onClickOuterLinkWithLinkText = function(url) {
        if ((0,RNPlugins/* isWebView */.vp)()) {
            navigate.navigateToPureWebViewAppScreen({
                uri: url
            });
        }
    };
    var onClickHospitalCta = function(hospitalPid) {
        (0,logger/* magazineLogger */.Uj)({
            eventName: logs_magazine/* MAGAZINE_LOG_EVENT.CLICK_MOVE_HOSPITAL_FROM_CTA */.W.CLICK_MOVE_HOSPITAL_FROM_CTA,
            pageName: pageName,
            payload: {
                magazinePid: magazinePid,
                hospitalPid: hospitalPid
            }
        });
        moveToHospitalDetail(hospitalPid);
    };
    var onClickMagazineBannerOutLink = function(link) {
        var ref, ref1, ref2;
        if (client.isWebView) {
            (0,RNPlugins/* sendPostMessageToNative */.T0)(RNPlugins/* NATIVE_POST_MESSAGE_TYPE.OPEN_EXTERNAL_BROWSER */.nn.OPEN_EXTERNAL_BROWSER, {
                url: link
            });
            return;
        }
        airbridgeDynamicLink.navigateWithTracking(deeplink/* DeeplinkLoggerEventName.ClickCtaButton */.l.ClickCtaButton, {
            campaign: "web_content_magazine",
            content: "web_content_bnr_details",
            term: (magazine === null || magazine === void 0 ? void 0 : (ref = magazine.banner) === null || ref === void 0 ? void 0 : ref.buttonPhrase) || "",
            sub_id: magazine === null || magazine === void 0 ? void 0 : magazine.magazinePid,
            sub_id_1: magazine === null || magazine === void 0 ? void 0 : magazine.title,
            sub_id_2: (diseaseTags === null || diseaseTags === void 0 ? void 0 : (ref1 = diseaseTags[0]) === null || ref1 === void 0 ? void 0 : ref1.name) || "",
            sub_id_3: (departmentTags === null || departmentTags === void 0 ? void 0 : (ref2 = departmentTags[0]) === null || ref2 === void 0 ? void 0 : ref2.name) || ""
        });
    };
    var goBack = function() {
        if (missionId && !missionCompleted) {
            showModal({
                type: modal/* MODAL_TYPE.ALERT */.f.ALERT,
                props: {
                    title: "아직 미션이 완료되지 않았어요",
                    message: "티켓을 받으려면 미션을 완료해야해요.",
                    buttons: [
                        {
                            type: modal/* MODAL_BUTTON_TYPE.DEFAULT */.J.DEFAULT,
                            label: "다음에 하기",
                            onClick: RNPlugins/* historyBack */.$i
                        },
                        {
                            type: modal/* MODAL_BUTTON_TYPE.PRIMARY */.J.PRIMARY,
                            label: "계속하기",
                            onClick: closeModal
                        }, 
                    ]
                }
            });
            return;
        }
        (0,RNPlugins/* historyBack */.$i)();
    };
    var isEnabledWebDiagnosisCategory = (magazine === null || magazine === void 0 ? void 0 : magazine.bottomButtonType) === types_magazine/* MagazineBottomButtonType.DIAGNOSIS */.wK.DIAGNOSIS && !client.isWebView;
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        if (!magazine) {
            return;
        }
        pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.PageIn */.$.PageIn, (0,_object_spread/* default */.Z)({}, (diseaseTags === null || diseaseTags === void 0 ? void 0 : (ref = diseaseTags[0]) === null || ref === void 0 ? void 0 : ref.name) && {
            disease: diseaseTags === null || diseaseTags === void 0 ? void 0 : (ref1 = diseaseTags[0]) === null || ref1 === void 0 ? void 0 : ref1.name
        }, (departmentTags === null || departmentTags === void 0 ? void 0 : (ref2 = departmentTags[0]) === null || ref2 === void 0 ? void 0 : ref2.name) && {
            subject: departmentTags === null || departmentTags === void 0 ? void 0 : (ref3 = departmentTags[0]) === null || ref3 === void 0 ? void 0 : ref3.name
        }, (symptomTags === null || symptomTags === void 0 ? void 0 : (ref4 = symptomTags[0]) === null || ref4 === void 0 ? void 0 : ref4.name) && {
            symptom: symptomTags === null || symptomTags === void 0 ? void 0 : (ref5 = symptomTags[0]) === null || ref5 === void 0 ? void 0 : ref5.name
        }));
        setIsCujModalTrackingInfo({
            campaignName: "web_content_magazine",
            trackContent: "web_content_mdl_details",
            contentId: magazine.magazinePid,
            contentTitle: magazine.title,
            contentCategory: (diseaseTags === null || diseaseTags === void 0 ? void 0 : (ref6 = diseaseTags[0]) === null || ref6 === void 0 ? void 0 : ref6.name) || "",
            contentSubCategory: (departmentTags === null || departmentTags === void 0 ? void 0 : (ref7 = departmentTags[0]) === null || ref7 === void 0 ? void 0 : ref7.name) || ""
        });
    }, [
        magazine
    ]);
    (0,react.useEffect)(function() {
        if (!missionId || !missionCompleted) {
            return;
        }
        completeMissionMutation.mutate({
            request: {
                missionId: missionId
            }
        }, {
            onSuccess: function() {
                broadCastChannel.postMessage(types/* UserMissionTypeVo.MagazineRead */.R.MagazineRead);
            }
        });
    }, [
        missionCompleted,
        missionId
    ]);
    return {
        bannerAdExchange: bannerAdExchange,
        totalRelatedMagazines: magazines,
        magazine: magazine,
        departmentTags: departmentTags !== null && departmentTags !== void 0 ? departmentTags : [],
        symptomTags: symptomTags !== null && symptomTags !== void 0 ? symptomTags : [],
        diseaseTags: diseaseTags !== null && diseaseTags !== void 0 ? diseaseTags : [],
        magazineContent: magazineContent !== null && magazineContent !== void 0 ? magazineContent : "",
        totalRelatedMagazinesTitle: totalRelatedMagazinesTitle,
        magazineTagNames: magazineTagNames,
        prevMagazinePid: prevMagazinePid,
        nextMagazinePid: nextMagazinePid,
        pageName: pageName,
        magazineRelatedQna: magazineRelatedQna,
        copyUrl: copyUrl,
        bottomButtonText: bottomButtonText,
        timerVisible: Boolean(missionId),
        displayTime: displayTime,
        missionCompleted: missionCompleted,
        missionTargetTime: MISSION_TARGET_TIME,
        handleSendExposureLog: handleSendExposureLog,
        onClickTag: onClickTag,
        handleLikeClick: handleLikeClick,
        moveOtherMagazine: moveOtherMagazine,
        onClickShare: onClickShare,
        onRecordLog: onRecordLog,
        moveToSearch: moveToSearch,
        moveToHospital: moveToHospital,
        moveToTotalSearch: moveToTotalSearch,
        handleStickyButton: handleStickyButton,
        moveToAuthorHospital: moveToAuthorHospital,
        magazineTocLogger: magazineTocLogger,
        onClickPrevNextMagazine: onClickPrevNextMagazine,
        onClickRelatedQna: onClickRelatedQna,
        onClickOuterLink: onClickOuterLink,
        extractTextFromChildren: extractTextFromChildren,
        onClickHospitalCta: onClickHospitalCta,
        goBack: goBack,
        onClickMagazineBannerOutLink: onClickMagazineBannerOutLink,
        shouldShowEventText: shouldShowEventText,
        navigateToMagazineAuthorDetail: navigateToMagazineAuthorDetail,
        onClickTopCta: onClickTopCta,
        onClickOuterLinkWithLinkText: onClickOuterLinkWithLinkText,
        getAirbridgeDynamicLink: getAirbridgeDynamicLink,
        airbridgeLinkOptions: airbridgeLinkOptions,
        isEnabledWebDiagnosisCategory: isEnabledWebDiagnosisCategory
    };
};
/* harmony default export */ var magazine_useMagazineDetailViewModel = (useMagazineDetailViewModel);

// EXTERNAL MODULE: ./src/shared/utils/format.ts
var format = __webpack_require__(64214);
// EXTERNAL MODULE: ./src/utils/format.ts
var utils_format = __webpack_require__(4611);
;// CONCATENATED MODULE: ./src/pages/content/magazine/[id]/index.tsx
// PageDescription: 매거진 상세 페이지


















var createMagazineDetailLdJson = function(magazineDetail) {
    if (!magazineDetail) {
        return {};
    }
    var aboutFilters = magazineDetail.tags.filter(function(tag) {
        return tag.tagType === types_magazine/* MagazineTagType.DISEASE */.Zg.DISEASE;
    });
    var isDoctor = magazineDetail.author.authorType === types_magazine/* AuthorType.DOCTOR */.Tq.DOCTOR;
    var author = (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "@type": "Person",
        name: magazineDetail.author.name
    }, magazineDetail.author.profileDescription && {
        description: magazineDetail.author.profileDescription
    }), {
        jobTitle: (0,format/* formatAuthorType */.m)(magazineDetail.author.authorType),
        url: "".concat("https://doctornow.co.kr", "/author/").concat(magazineDetail.author.authorPublicId),
        image: isDoctor ? magazineDetail.author.profileImageUrl : "https://media.doctornow.co.kr/og-qna.png",
        affiliation: {
            "@type": "Organization",
            name: magazineDetail.author.affiliatedInstitutionName
        }
    }), magazineDetail.author.careers.length > 0 && {
        alumniOf: magazineDetail.author.careers.map(function(career) {
            return {
                "@type": "Organization",
                name: career.content
            };
        })
    });
    return [
        (0,_object_spread/* default */.Z)({
            "@context": "https://schema.org",
            "@type": "Article",
            "@id": "".concat("https://doctornow.co.kr").concat(types_common/* ROUTES.MAGAZINE.DETAIL.path */.Z6.MAGAZINE.DETAIL.path, "/").concat(magazineDetail.magazinePid),
            headline: magazineDetail.title,
            name: "닥터나우 건강매거진",
            description: magazineDetail.description,
            articleBody: (0,utils_format/* convertMarkdownToPlainText */.BN)(magazineDetail.content),
            image: [
                magazineDetail === null || magazineDetail === void 0 ? void 0 : magazineDetail.titleImageUrl
            ],
            datePublished: dayjs_min_default()(magazineDetail === null || magazineDetail === void 0 ? void 0 : magazineDetail.createdAt).format("YYYY-MM-DDTHH:mm:ss[Z]"),
            author: author,
            publisher: {
                "@type": "Organization",
                name: "닥터나우",
                url: "".concat("https://doctornow.co.kr")
            },
            url: "".concat("https://doctornow.co.kr").concat(types_common/* ROUTES.MAGAZINE.DETAIL.path */.Z6.MAGAZINE.DETAIL.path, "/").concat(magazineDetail.magazinePid)
        }, aboutFilters.length > 0 && {
            about: aboutFilters.map(function(tag) {
                return {
                    "@type": "MedicalCondition",
                    name: tag.name
                };
            }),
            keywords: magazineDetail.tags.map(function(tag) {
                return tag.name;
            }).join(", ")
        }),
        {
            "@context": "https://schema.org",
            "@type": "MedicalWebPage",
            image: [
                magazineDetail === null || magazineDetail === void 0 ? void 0 : magazineDetail.titleImageUrl
            ],
            headline: magazineDetail.title,
            name: "닥터나우 건강매거진",
            author: author,
            url: "".concat("https://doctornow.co.kr").concat(types_common/* ROUTES.MAGAZINE.DETAIL.path */.Z6.MAGAZINE.DETAIL.path, "/").concat(magazineDetail.magazinePid),
            mainEntity: {
                "@type": "Article",
                "@id": "".concat("https://doctornow.co.kr").concat(types_common/* ROUTES.MAGAZINE.DETAIL.path */.Z6.MAGAZINE.DETAIL.path, "/").concat(magazineDetail.magazinePid)
            }
        },
        {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "닥터나우",
            url: "".concat("https://doctornow.co.kr"),
            logo: "https://media.doctornow.co.kr/og-main.png",
            contactPoint: [
                {
                    "@type": "ContactPoint",
                    email: "contact@doctornow.co.kr",
                    contactType: "customer service"
                }, 
            ]
        }, 
    ];
};
var MagazineDetail = function(param) {
    var id = param.id, client = param.client;
    var router = (0,useCustomRouter/* default */.Z)().router;
    var viewModel = magazine_useMagazineDetailViewModel({
        magazinePid: id,
        client: client,
        missionId: router.query.missionId
    });
    var topBannerViewModel = (0,useAppInstallTopBanner/* default */.Z)();
    var magazineDetail = viewModel.magazine;
    var ldJson = createMagazineDetailLdJson(viewModel.magazine);
    var hasJapaneseContent = (magazineDetail === null || magazineDetail === void 0 ? void 0 : magazineDetail.hasJapanese) && (magazineDetail === null || magazineDetail === void 0 ? void 0 : magazineDetail.contentType) === types_magazine/* MagazineType.ARTICLE */.rL.ARTICLE;
    var alternateKR = [
        {
            hrefLang: "ko",
            href: "https://doctornow.co.kr/content/magazine/".concat(id)
        },
        {
            hrefLang: "ko-KR",
            href: "https://doctornow.co.kr/content/magazine/".concat(id)
        },
        {
            hrefLang: "x-default",
            href: "https://doctornow.co.kr/content/magazine/".concat(id)
        }, 
    ];
    var alternateJP = [
        {
            hrefLang: "ja",
            href: "https://doctornow.jp/magazine/".concat(id)
        },
        {
            hrefLang: "ja-JP",
            href: "https://doctornow.jp/magazine/".concat(id)
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(ldJson)
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "".concat(magazineDetail === null || magazineDetail === void 0 ? void 0 : magazineDetail.title, " - 닥터나우"),
                canonical: "".concat("https://doctornow.co.kr").concat(types_common/* ROUTES.MAGAZINE.DETAIL.path */.Z6.MAGAZINE.DETAIL.path, "/").concat(id),
                description: "".concat(magazineDetail === null || magazineDetail === void 0 ? void 0 : magazineDetail.description),
                openGraph: {
                    url: "".concat("https://doctornow.co.kr").concat(url/* Urls.Magazine */.n.Magazine, "/").concat(id),
                    title: (magazineDetail === null || magazineDetail === void 0 ? void 0 : magazineDetail.title) || "",
                    description: (magazineDetail === null || magazineDetail === void 0 ? void 0 : magazineDetail.description) || "",
                    images: [
                        {
                            url: (magazineDetail === null || magazineDetail === void 0 ? void 0 : magazineDetail.titleImageUrl) || "",
                            alt: "Og Image Alt"
                        }, 
                    ]
                },
                twitter: {
                    handle: "@doctornow",
                    site: "@doctornow.co.kr",
                    cardType: "summary_large_image"
                },
                languageAlternates: hasJapaneseContent ? (0,_to_consumable_array/* default */.Z)(alternateKR).concat((0,_to_consumable_array/* default */.Z)(alternateJP)) : alternateKR
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(magazine_detail_template/* default */.ZP, {
                viewModel: viewModel,
                topBannerViewModel: topBannerViewModel,
                client: client
            })
        ]
    });
};
MagazineDetail.Layout = DefaultLayout/* default */.Z;
var __N_SSP = true;
/* harmony default export */ var _id_ = (MagazineDetail);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1498,2498,3969,7160,4051,9653,1743,4365,2149,1950,4429,2367,948,8307,9774,2888,179], function() { return __webpack_exec__(42459); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);